<template>
  <ConversionDetailContent
    :s-transaction-id="$route.params.sTransactionId"
    @close="$router.go(-1)"
    @go-to-payment="goToPayment"
    @go-to-invoice="goToInvoice"
  />
</template>

<script>
import ConversionDetailContent from "./ConversionDetailContent.vue";

export default {
  name: "ConversionDetail",
  components: {
    ConversionDetailContent,
  },
  methods: {
    goToPayment(item) {
      this.$router.push({
        name: "PaymentDetail",
        params: { sPaymentId: item.sPaymentId }
      }).catch(() => {});
    },
    goToInvoice(item) {
      this.$router.push({
        name: "InvoiceDetail",
        params: { sInvoiceId: item.invoice.sInvoiceId }
      }).catch(() => {});
    },
  },
};
</script>
